import { render, staticRenderFns } from "./RemortgageAboutYou.vue?vue&type=template&id=5a44a1d0&"
import script from "./RemortgageAboutYou.vue?vue&type=script&lang=js&"
export * from "./RemortgageAboutYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports